/* const exampleInput = {
  Article: ['id', ({version}) => version],
  Teaser: ['articleId', 'articleVersion', 'identifier']
} */

export default (types, defaultCacheIdFromObject, delimiter = ':') => obj => {
  const cacheFields = types[obj.__typename];
  if (!cacheFields) return defaultCacheIdFromObject(obj);
  return cacheFields.reduce((cacheId, cacheField) => {
    let cacheFieldValue = typeof cacheField === 'function' ? cacheField(obj) : obj[cacheField];
    if (typeof cacheFieldValue === 'undefined' || cacheFieldValue === null) {
      throw new Error(`${obj.__typename} field '${cacheField}' is mandatory for caching!`);
    }
    return `${cacheId}${delimiter}${cacheFieldValue}`;
  }, obj.__typename);
};
